// Indonesian translations
export const id: Record<string, string> = {
  // ==================== COMMON ====================
  'common.loading': 'Memuat...',
  'common.error': 'Terjadi kesalahan',
  'common.retry': 'Coba lagi',
  'common.cancel': 'Batal',
  'common.save': 'Simpan',
  'common.continue': 'Lanjutkan',
  'common.back': 'Kembali',
  'common.next': 'Selanjutnya',
  'common.skip': 'Lewati',
  'common.done': 'Selesai',
  'common.yes': 'Ya',
  'common.no': 'Tidak',
  'common.ok': 'OK',
  'common.check': 'Periksa',
  'common.correct': 'Benar!',
  'common.incorrect': 'Salah',
  'common.tryAgain': 'Coba lagi',
  'common.start': 'Mulai',
  'common.finish': 'Selesai',
  'common.submit': 'Kirim',

  // ==================== NAVIGATION ====================
  'nav.home': 'Beranda',
  'nav.courses': 'Kursus',
  'nav.vocabulary': 'Kosakata',
  'nav.profile': 'Profil',
  'nav.settings': 'Pengaturan',
  'nav.logout': 'Keluar',
  'nav.leaderboard': 'Papan Peringkat',
  'nav.aiTutor': 'Tutor AI',

  // ==================== ONBOARDING ====================
  'onboarding.welcome': 'Selamat datang di KoreanFlow!',
  'onboarding.selectLanguage': 'Pilih bahasa Anda',
  'onboarding.selectLanguageDesc': 'Pilih bahasa untuk antarmuka aplikasi',
  'onboarding.selectGoal': 'Apa tujuan belajar Anda?',
  'onboarding.selectGoalDesc': 'Kami akan menyesuaikan jalur pembelajaran Anda',
  'onboarding.takeTest': 'Ikuti Tes Level',
  'onboarding.takeTestDesc': 'Temukan level bahasa Korea Anda dalam 5 menit',
  'onboarding.skipTest': 'Lewati dulu',
  'onboarding.skipTestDesc': 'Mulai dari awal',
  'onboarding.letsGo': 'Ayo Mulai!',
  'onboarding.step': 'Langkah',
  'onboarding.of': 'dari',

  // ==================== LEVEL TEST ====================
  'levelTest.title': 'Tes Level',
  'levelTest.subtitle': 'Mari temukan level bahasa Korea Anda',
  'levelTest.duration': 'Sekitar 5 menit',
  'levelTest.questions': 'pertanyaan',
  'levelTest.vocabulary': 'Kosakata',
  'levelTest.grammar': 'Tata Bahasa',
  'levelTest.listening': 'Mendengarkan',
  'levelTest.speaking': 'Berbicara',
  'levelTest.analyzing': 'Menganalisis hasil Anda...',
  'levelTest.yourLevel': 'Level Anda',
  'levelTest.congratulations': 'Selamat!',
  'levelTest.resultDesc': 'Berdasarkan hasil tes Anda',
  'levelTest.startLearning': 'Mulai Belajar',
  'levelTest.retakeTest': 'Ulangi Tes',
  'levelTest.sectionComplete': 'Bagian Selesai',
  'levelTest.nextSection': 'Bagian Berikutnya',
  'levelTest.listenAndAnswer': 'Dengarkan dan jawab',
  'levelTest.speakNow': 'Bicara sekarang',
  'levelTest.tapToListen': 'Ketuk untuk mendengarkan',

  // ==================== CEFR LEVELS ====================
  'cefr.A1': 'Pemula',
  'cefr.A2': 'Dasar',
  'cefr.B1': 'Menengah',
  'cefr.B2': 'Menengah Atas',
  'cefr.C1': 'Mahir',
  'cefr.C2': 'Sangat Mahir',
  'cefr.A1.desc': 'Sapaan dasar dan ekspresi sederhana',
  'cefr.A2.desc': 'Percakapan sederhana tentang kehidupan sehari-hari',
  'cefr.B1.desc': 'Dapat menangani sebagian besar situasi perjalanan',
  'cefr.B2.desc': 'Dapat berinteraksi lancar dengan penutur asli',
  'cefr.C1.desc': 'Dapat mengekspresikan ide dengan lancar dan spontan',
  'cefr.C2.desc': 'Kemampuan mendekati penutur asli dalam semua situasi',

  // ==================== LEAGUE / RANKING ====================
  'league.title': 'Liga',
  'league.weeklyRanking': 'Peringkat Mingguan',
  'league.bronze': 'Perunggu',
  'league.silver': 'Perak',
  'league.gold': 'Emas',
  'league.platinum': 'Platinum',
  'league.diamond': 'Berlian',
  'league.promotion': 'Zona Promosi',
  'league.demotion': 'Zona Degradasi',
  'league.safe': 'Zona Aman',
  'league.weeklyXP': 'XP Mingguan',
  'league.rank': 'Peringkat',
  'league.daysLeft': 'hari tersisa',
  'league.promoted': 'Dipromosikan!',
  'league.demoted': 'Terdegradasi',
  'league.stayed': 'Tetap',
  'league.noData': 'Belum ada data peringkat',
  'league.earnXP': 'Dapatkan XP untuk bergabung dengan liga!',
  'league.topPercent': 'Top {percent}%',

  // ==================== LANDING PAGE ====================
  'landing.tagline': 'Aplikasi Belajar Korea #1',
  'landing.title': 'Belajar Bahasa Korea',
  'landing.titleAccent': 'Dengan Cara Menyenangkan',
  'landing.subtitle': 'Kuasai bahasa Korea dengan pelajaran singkat, konten budaya tradisional, dan feedback pengucapan bertenaga AI. Bergabung dengan 1 juta+ pelajar!',
  'landing.getStarted': 'Mulai Gratis',
  'landing.learnMore': 'Pelajari Lebih Lanjut',
  'landing.login': 'Masuk',
  'landing.startFree': 'Mulai Gratis',
  'landing.learners': 'Pelajar',
  'landing.lessons': 'Pelajaran',
  'landing.countries': 'Negara',

  // ==================== FEATURES ====================
  'features.title': 'Mengapa KoreanFlow?',
  'features.subtitle': 'Pendekatan unik kami menggabungkan gamifikasi, konten autentik, dan teknologi AI untuk membuat belajar bahasa Korea menyenangkan dan efektif.',
  'features.streaks.title': 'Streak Harian',
  'features.streaks.desc': 'Bangun kebiasaan dengan target harian dan hadiah streak. Tetap termotivasi dengan XP dan gems.',
  'features.folksong.title': 'Lagu Rakyat',
  'features.folksong.desc': 'Belajar Korea melalui lagu rakyat tradisional. Pahami lirik dan budaya!',
  'features.culture.title': 'Budaya Korea',
  'features.culture.desc': 'Jelajahi peribahasa, bahasa gaul, dan frasa penting. Kuasai ekspresi autentik.',
  'features.ai.title': 'Chatbot AI',
  'features.ai.desc': 'Latihan percakapan dengan tutor AI kami. Dapatkan feedback dan koreksi instan.',
  'features.leaderboard.title': 'Papan Peringkat',
  'features.leaderboard.desc': 'Bersaing dengan teman dan pelajar seluruh dunia. Naiki peringkat mingguan!',
  'features.srs.title': 'Kosakata SRS',
  'features.srs.desc': 'Sistem pengulangan cerdas memastikan kamu mengingat apa yang dipelajari. Selamanya.',
  'features.pronunciation.title': 'Feedback Pengucapan',
  'features.pronunciation.desc': 'Analisis pengucapan bertenaga AI dengan skor detail.',

  // ==================== CTA ====================
  'cta.title': 'Siap Memulai Perjalananmu?',
  'cta.subtitle': 'Bergabung dengan jutaan pelajar dan mulai berbicara bahasa Korea hari ini. Gratis!',
  'cta.button': 'Mulai Belajar Gratis',

  // ==================== AUTH ====================
  'auth.login': 'Masuk',
  'auth.register': 'Daftar',
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'Masukkan email kamu',
  'auth.password': 'Kata Sandi',
  'auth.passwordPlaceholder': 'Buat kata sandi',
  'auth.confirmPassword': 'Konfirmasi Kata Sandi',
  'auth.forgotPassword': 'Lupa kata sandi?',
  'auth.noAccount': 'Belum punya akun?',
  'auth.haveAccount': 'Sudah punya akun?',
  'auth.orContinueWith': 'atau lanjutkan dengan',
  'auth.google': 'Google',
  'auth.apple': 'Apple',
  'auth.createAccount': 'Buat Akun',
  'auth.createAccountTitle': 'Buat Akun Baru',
  'auth.createAccountSubtitle': 'Mulai perjalanan belajar bahasa Korea hari ini',
  'auth.username': 'Nama Pengguna',
  'auth.usernamePlaceholder': 'Pilih nama pengguna',
  'auth.usernameHint': 'Hanya huruf, angka, dan garis bawah',
  'auth.passwordHint': 'Minimal 8 karakter dengan huruf besar, kecil, dan angka',
  'auth.nativeLanguage': 'Bahasa Ibu',
  'auth.nativeLanguageHint': 'Penjelasan akan ditampilkan dalam bahasa ini',
  'auth.termsAgree': 'Dengan mendaftar, kamu setuju dengan',
  'auth.terms': 'Ketentuan Layanan',
  'auth.and': 'dan',
  'auth.privacyPolicy': 'Kebijakan Privasi',
  'auth.loginTitle': 'Selamat Datang Kembali',
  'auth.loginSubtitle': 'Masuk untuk melanjutkan belajar',
  'auth.loginButton': 'Masuk',
  'auth.registerButton': 'Daftar',
  'auth.rememberMe': 'Ingat saya',

  // ==================== DASHBOARD ====================
  'dashboard.welcome': 'Selamat datang kembali',
  'dashboard.todayGoal': 'Target Hari Ini',
  'dashboard.streak': 'Streak',
  'dashboard.days': 'hari',
  'dashboard.xp': 'XP',
  'dashboard.level': 'Level',
  'dashboard.continueLearning': 'Lanjutkan Belajar',
  'dashboard.recommended': 'Direkomendasikan untuk Anda',
  'dashboard.myCourses': 'Kursus Saya',
  'dashboard.seeAll': 'Lihat Semua',
  'dashboard.dailyGoalComplete': 'Target harian tercapai!',
  'dashboard.keepGoing': 'Terus semangat!',
  'dashboard.yourLevel': 'Level Anda',
  'dashboard.weeklyProgress': 'Progres Mingguan',

  // ==================== COURSES ====================
  'courses.title': 'Semua Kursus',
  'courses.search': 'Cari kursus...',
  'courses.all': 'Semua',
  'courses.beginner': 'Pemula',
  'courses.elementary': 'Dasar',
  'courses.intermediate': 'Menengah',
  'courses.advanced': 'Lanjutan',
  'courses.lessons': 'pelajaran',
  'courses.enrolled': 'terdaftar',
  'courses.progress': 'Progres',
  'courses.completed': 'selesai',
  'courses.recommended': 'Direkomendasikan',
  'courses.forYourLevel': 'Untuk level Anda',
  'courses.locked': 'Terkunci',
  'courses.unlockWith': 'Buka dengan Premium',

  // ==================== LESSON ====================
  'lesson.loading': 'Memuat pelajaran...',
  'lesson.notFound': 'Pelajaran tidak ditemukan',
  'lesson.quit': 'Yakin mau keluar? Progresmu akan hilang.',
  'lesson.complete': 'Pelajaran Selesai!',
  'lesson.perfect': 'Sempurna!',
  'lesson.amazing': 'Luar biasa! Kamu menjawab semuanya dengan benar!',
  'lesson.xpEarned': 'XP Didapat',
  'lesson.accuracy': 'Akurasi',
  'lesson.correct': 'Benar',
  'lesson.goBack': 'Kembali',
  'lesson.skip': 'Lewati',
  'lesson.unknownType': 'Jenis latihan tidak dikenal',

  // ==================== EXERCISES ====================
  'exercise.tapToReveal': 'Ketuk untuk lihat jawaban',
  'exercise.matchPairs': 'Cocokkan pasangan',
  'exercise.matched': 'dicocokkan',
  'exercise.arrangeWords': 'Susun kata-kata',
  'exercise.speak': 'Ucapkan',
  'exercise.listening': 'Mendengarkan... Bicara sekarang!',
  'exercise.processing': 'Memproses ucapanmu...',
  'exercise.tapToSpeak': 'Ketuk untuk berbicara',
  'exercise.cantSpeak': 'Tidak bisa bicara sekarang? Lewati',
  'exercise.again': 'Lagi',
  'exercise.gotIt': 'Paham!',

  // ==================== PRONUNCIATION ====================
  'pronunciation.title': 'Latihan Pengucapan',
  'pronunciation.subtitle': 'Tingkatkan pengucapan bahasa Korea Anda dengan feedback AI',
  'pronunciation.selectLevel': 'Pilih Level Anda',
  'pronunciation.beginner': 'Pemula',
  'pronunciation.intermediate': 'Menengah',
  'pronunciation.advanced': 'Lanjutan',
  'pronunciation.score': 'Skor Anda',
  'pronunciation.accuracy': 'Akurasi',
  'pronunciation.fluency': 'Kelancaran',
  'pronunciation.intonation': 'Intonasi',
  'pronunciation.feedback': 'Feedback',
  'pronunciation.tryAgain': 'Coba Lagi',
  'pronunciation.next': 'Berikutnya',
  'pronunciation.listen': 'Dengarkan',
  'pronunciation.slow': 'Lambat',
  'pronunciation.sessionComplete': 'Sesi Selesai!',
  'pronunciation.bestScore': 'Skor Terbaik',
  'pronunciation.average': 'Rata-rata',
  'pronunciation.attempts': 'Percobaan',
  'pronunciation.practiceAgain': 'Latihan Lagi',
  'pronunciation.changeLevel': 'Ganti Level',
  'pronunciation.tips': 'Tips untuk Pengucapan Lebih Baik',
  'pronunciation.tip1': 'Dengarkan audio terlebih dahulu',
  'pronunciation.tip2': 'Bicara dengan jelas dan tempo stabil',
  'pronunciation.tip3': 'Gunakan pemutaran lambat untuk kata sulit',
  'pronunciation.tip4': 'Latihan di lingkungan yang tenang',

  // ==================== VOCABULARY ====================
  'vocab.title': 'Kosakata',
  'vocab.totalWords': 'Total Kata',
  'vocab.mastered': 'Dikuasai',
  'vocab.dueToday': 'Hari Ini',
  'vocab.reviewSession': 'Sesi Review',
  'vocab.wordsDue': 'kata perlu direview',
  'vocab.startReview': 'Mulai Review',
  'vocab.allCaughtUp': 'Semua sudah direview!',
  'vocab.noWordsDue': 'Tidak ada kata untuk direview',
  'vocab.sessionComplete': 'Sesi Selesai!',
  'vocab.allWords': 'Semua Kata',

  // ==================== PROFILE ====================
  'profile.title': 'Profil',
  'profile.level': 'Level',
  'profile.xpToNext': 'XP ke level selanjutnya',
  'profile.totalXp': 'Total XP',
  'profile.currentStreak': 'Streak Saat Ini',
  'profile.lessonsDone': 'Pelajaran Selesai',
  'profile.timeLearned': 'Waktu Belajar',
  'profile.achievements': 'Pencapaian',
  'profile.settings': 'Pengaturan',
  'profile.dailyGoals': 'Target Harian',
  'profile.allAchievements': 'Semua Pencapaian',
  'profile.logOut': 'Keluar',
  'profile.koreanLevel': 'Level Bahasa Korea',

  // ==================== SETTINGS ====================
  'settings.title': 'Pengaturan',
  'settings.language': 'Bahasa Aplikasi',
  'settings.preferences': 'Preferensi',
  'settings.sound': 'Efek Suara',
  'settings.soundEffects': 'Efek Suara',
  'settings.soundEffectsDesc': 'Putar suara saat menjawab latihan',
  'settings.notifications': 'Notifikasi',
  'settings.notificationsDesc': 'Terima pengingat belajar harian',
  'settings.darkMode': 'Mode Gelap',
  'settings.darkModeDesc': 'Tampilan gelap untuk mata yang lebih nyaman',
  'settings.dailyReminder': 'Pengingat Harian',
  'settings.account': 'Akun',
  'settings.editProfile': 'Edit Profil',
  'settings.terms': 'Ketentuan Layanan',
  'settings.privacy': 'Kebijakan Privasi',
  'settings.help': 'Bantuan',
  'settings.about': 'Tentang',
  'settings.retakeTest': 'Ulangi Tes Level',
  'settings.retakeTestDesc': 'Periksa level bahasa Korea Anda saat ini',

  // ==================== FOOTER ====================
  'footer.privacy': 'Privasi',
  'footer.terms': 'Ketentuan',
  'footer.contact': 'Kontak',
  'footer.rights': 'Hak cipta dilindungi.',

  // ==================== COOKIE CONSENT ====================
  'cookie.title': 'Kami menggunakan cookie',
  'cookie.description': 'Kami menggunakan cookie untuk meningkatkan pengalaman Anda, menganalisis lalu lintas situs, dan mempersonalisasi konten. Anda dapat memilih untuk menerima atau menolak cookie non-esensial.',
  'cookie.learnMore': 'Pelajari lebih lanjut',
  'cookie.acceptAll': 'Terima Semua',
  'cookie.rejectAll': 'Tolak Semua',

  // ==================== QUICK ACTIONS ====================
  'quickAction.vocabulary': 'Kosakata',
  'quickAction.reviewWords': 'Review kata',
  'quickAction.allCourses': 'Semua Kursus',
  'quickAction.browseLessons': 'Jelajahi pelajaran',

  // ==================== COURSE DETAIL ====================
  'courseDetail.notFound': 'Kursus tidak ditemukan',
  'courseDetail.lessons': 'pelajaran',
  'courseDetail.completed': 'selesai',

  // ==================== BOTTOM NAVIGATION ====================
  'bottomNav.home': 'Beranda',
  'bottomNav.courses': 'Kursus',
  'bottomNav.vocab': 'Kosakata',
  'bottomNav.profile': 'Profil',

  // ==================== AI TUTOR ====================
  'aiTutor.title': 'Tutor AI',
  'aiTutor.selectScenario': 'Pilih skenario',
  'aiTutor.freeTalk': 'Obrolan Bebas',
  'aiTutor.cafe': 'Pesan di Kafe',
  'aiTutor.shopping': 'Belanja',
  'aiTutor.restaurant': 'Restoran',
  'aiTutor.friends': 'Berteman',
  'aiTutor.interview': 'Wawancara Kerja',
  'aiTutor.typeMessage': 'Ketik pesan...',
  'aiTutor.send': 'Kirim',

  // ==================== ERRORS ====================
  'error.generic': 'Terjadi kesalahan',
  'error.network': 'Kesalahan jaringan. Periksa koneksi Anda.',
  'error.notFound': 'Halaman tidak ditemukan',
  'error.unauthorized': 'Silakan masuk untuk melanjutkan',
  'error.microphoneAccess': 'Akses mikrofon ditolak',
  'error.speechNotSupported': 'Pengenalan suara tidak didukung. Coba Chrome.',
  // ==================== ADDED (i18n audit 2026-10-24) ====================
  'nav.learn': 'Belajar',
  'nav.culture': 'Budaya',
  'nav.chat': 'Obrolan',
  'nav.ranking': 'Peringkat',
  'nav.family': 'Keluarga',
  'nav.premium': 'Premium',
  'home.greeting': 'Halo',
  'home.streak': 'hari beruntun',
  'home.dailyGoal': 'Target Harian',
  'home.myLanguages': 'Bahasa Saya',
  'home.addLanguage': 'Tambah Bahasa',
  'home.recommended': 'Direkomendasikan',
  'home.continue': 'Lanjutkan Belajar',
  'home.selectLanguage': 'Pilih bahasa',
  'home.totalXp': 'Total XP',
  'home.bestStreak': 'Rekor Beruntun',
  'home.level': 'Level',
  'chat.aiTutor': 'Tutor AI',
  'chat.aiTutorDesc': 'Latihan percakapan dengan AI',
  'onboarding.welcome.subtitle': 'Pelajari bahasa apa pun lewat percakapan bertenaga AI',
  'onboarding.selectUILanguage': 'Pilih bahasa Anda',
  'onboarding.selectUILanguage.subtitle': 'Ini akan dipakai untuk antarmuka aplikasi',
  'onboarding.selectLearningLanguage': 'Apa yang ingin Anda pelajari?',
  'onboarding.selectLearningLanguage.subtitle': 'Anda bisa belajar beberapa bahasa',
  'onboarding.selectDailyGoal': 'Atur target harian',
  'onboarding.selectDailyGoal.subtitle': 'Berapa waktu yang bisa Anda luangkan tiap hari?',
  'onboarding.ready': 'Semua siap!',
  'onboarding.ready.subtitle': 'Yuk mulai perjalanan belajar bahasa Anda',
  'onboarding.features.languages': '4 Bahasa',
  'onboarding.features.aiTutor': 'Tutor AI',
  'onboarding.features.dailyGoals': 'Target Harian',
  'dailyGoal.5min': '5 menit',
  'dailyGoal.10min': '10 menit',
  'dailyGoal.15min': '15 menit',
  'dailyGoal.20min': '20 menit',
  'dailyGoal.casual': 'Santai',
  'dailyGoal.regular': 'Latihan rutin',
  'dailyGoal.serious': 'Pelajar serius',
  'dailyGoal.intense': 'Latihan intensif',
  'learn.title': 'Belajar',
  'learn.currentLevel': 'Level Saat Ini',
  'learn.noCoursesYet': 'Segera Hadir!',
  'learn.noCoursesDescription': 'Kursus untuk bahasa ini sedang disiapkan.',
  'learn.lessonsCompleted': 'pelajaran selesai',
  'learn.startCourse': 'Mulai Kursus',
  'learn.continueCourse': 'Lanjutkan',
  'learn.courseCompleted': 'Selesai',
  'learn.locked': 'Terkunci',
  'learn.unlockBy': 'Selesaikan kursus sebelumnya untuk membuka',
  'course.progress': 'Kemajuan',
  'course.lessons': 'Pelajaran',
  'course.lessonsCompleted': 'pelajaran selesai',
  'course.noLessons': 'Pelajaran sedang disiapkan...',
  'lesson.tapToReveal': 'Ketuk untuk melihat arti',
  'lesson.examples': 'Contoh',
  'lesson.questionsCorrect': 'benar',
  'lesson.wordsLearned': 'Kata',
  'lesson.grammarPoints': 'Tata Bahasa',
  'lesson.backToCourse': 'Kembali ke Kursus',
  'lesson.practiceAgain': 'Latihan Lagi',
  'lesson.whatYouLearn': 'Yang akan Anda pelajari',
  'lesson.newWords': 'kata baru',
  'lesson.exercises': 'latihan',
  'lesson.startLesson': 'Mulai Pelajaran',
  'lesson.reviewLesson': 'Ulas Pelajaran',
  'lesson.learnVocabulary': 'Pelajari Kosakata',
  'lesson.grammarPoint': 'Poin Tata Bahasa',
  'lesson.practice': 'Latihan',
  'profile.guest': 'Tamu',
  'profile.days': 'hari',
  'profile.longestStreak': 'Terpanjang',
  'profile.lessonsCompleted': 'selesai',
  'profile.dailyGoal': 'Target Harian',
  'profile.learningLanguages': 'Bahasa yang Dipelajari',
  'profile.noLanguages': 'Belum ada bahasa dipilih',
  'profile.minutesPerDay': 'mnt/hari',
  'profile.learningHistory': 'Riwayat Belajar',
  'profile.viewProgress': 'Lihat kemajuan Anda',
  'profile.appSettings': 'Pengaturan Aplikasi',
  'profile.languageNotifications': 'Bahasa, notifikasi',
  'profile.loginToSave': 'Masuk untuk menyimpan kemajuan Anda',
  'settings.learning': 'Pembelajaran',
  'settings.dailyGoal': 'Target Harian',
  'settings.minutesPerDay': 'menit per hari',
  'settings.selectLanguage': 'Pilih Bahasa',
  'settings.selectDailyGoal': 'Atur Target Harian',
  'settings.perDay': 'per hari',
  'settings.appInfo': 'Info Aplikasi',
  'settings.logout': 'Keluar',
};

export default id;
